<template>
  <!--
    DsBadge — label de estado NO interactivo (elements/badge/badge.css).
    Mono · caption · uppercase · CUADRADO. Rotula un estado, sin hover/press.
    (El interactivo/seleccionable es DsChip.) Tonos: live/coming/neutral/default.
  -->
  <span class="ds-badge" :class="tone !== 'default' && `ds-badge--${tone}`">
    <slot />
  </span>
</template>

<script>
export default {
  name: 'DsBadge',
  props: {
    tone: {
      type: String,
      default: 'default',
      validator: (v) => ['default', 'live', 'coming', 'neutral'].includes(v),
    },
  },
};
</script>

<style scoped lang="scss">
.ds-badge {
  display: inline-flex;      // inline-flex (era inline-block) → alinea icono opcional + texto
  align-items: center;
  gap: 4px;
  font-family: var(--font-mono);
  font-size: var(--text-caption-size);
  letter-spacing: var(--text-caption-track);
  text-transform: uppercase;
  line-height: 1;
  padding: 5px 10px;
  border: 1px solid currentColor;
  border-radius: var(--radius-sm);
  white-space: nowrap;
  box-sizing: border-box;
}
/* Tonos — solo color; el border sigue por currentColor. Semánticos → surface-aware. */
.ds-badge--live { color: var(--text-accent); }   /* texto → teal-300 en slate, no el teal-500 de fill */
.ds-badge--coming { color: var(--accent-active); }
.ds-badge--neutral { color: var(--text-muted); }
</style>
